import i18n from '@/store/i18n';

const getYearFormat = () => {
  const locales = {
    ja: 'YYYY年',
    ko: 'YYYY년',
    DEFAULT: 'YYYY',
  };
  return locales[i18n.global.locale] || locales.DEFAULT;
};

const getMonthFormat = () => {
  const locales = {
    ja: 'MMM',
    ko: 'MMMM',
    DEFAULT: 'MMMM',
  };
  return locales[i18n.global.locale] || locales.DEFAULT;
};

const getYearMonthFormat = () => {
  const locales = {
    ja: 'YYYY年M月',
    ko: 'YYYY년 MMMM',
    DEFAULT: 'MMMM, YYYY',
  };
  return locales[i18n.global.locale] || locales.DEFAULT;
};

const getYearMonthShortFormat = () => {
  const locales = {
    ja: 'YYYY年M月',
    ko: 'YYYY년 MMMM',
    DEFAULT: 'MMM, YYYY',
  };
  return locales[i18n.global.locale] || locales.DEFAULT;
};

const getMonthDayFormat = () => {
  const locales = {
    ja: 'M月D日',
    ko: 'MMMM D일',
    DEFAULT: 'MMMM D',
  };
  return locales[i18n.global.locale] || locales.DEFAULT;
};

const getMonthDayWeekdayFormat = () => {
  const data = getMonthDayFormat();
  return `${data} (ddd)`;
};

const getYearMonthDayFormat = () => {
  const locales = {
    ja: 'YYYY年M月D日',
    ko: 'YYYY년 MMMM D일',
    DEFAULT: 'MMM D, YYYY',
  };

  return locales[i18n.global.locale] || locales.DEFAULT;
};

const getYearMonthDayWeekdayFormat = () => {
  const data = getYearMonthDayFormat();
  return `${data} (ddd)`;
};

export const SYSTEM_MONTH_FORMAT = 'YYYY-MM';
export const SYSTEM_DATE_FORMAT = 'YYYY-MM-DD';
export const SYSTEM_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const DEFAULT_FORMAT_DATE = { year: 'numeric', month: 'short', day: 'numeric' };
export const DATE_UI_YEAR_MONTH_DAY_WEEKDAY = getYearMonthDayWeekdayFormat();
export const DATE_UI_YEAR_MONTH_DAY = getYearMonthDayFormat();
export const DATE_UI_YEAR_MONTH = getYearMonthFormat();
export const DATE_UI_YEAR_MONTH_SHORT = getYearMonthShortFormat();
export const DATE_UI_YEAR = getYearFormat();
export const DATE_UI_MONTH = getMonthFormat();
export const DATE_UI_MONTH_DAY = getMonthDayFormat();
export const DATE_UI_MONTH_DAY_WEEKDAY = getMonthDayWeekdayFormat();
export const DATE_UI_SHORT_MONTH_DAY_WEEKDAY = 'MMM Do (ddd)';
